/* eslint-disable */
import fetch from "../utils/fetch";

/**
 * stripe订阅
 * http://schedulepost.dev.apphi.com/api/docs/#!/subscriptions/Subscription_create_stripe_subscription
 * @param publisherId
 * @param plan_id 计划标识
 * @param stripe_token stripe token
 * @param name 姓名
 * @param coupon 优惠码
 * @param immediate_downgrade_token 通过降级链接降级时多穿的token 2019.6.29
 * @returns {*}
 */
export function stripePay({
  plan_id,
  stripe_token,
  name,
  coupon,
  immediate_downgrade_token
}) {
  return fetch.post(
    "subscriptions/stripe",
    { plan_id, stripe_token, name, coupon, immediate_downgrade_token },
    {
      timeout: 90000
    }
  );
}

/**
 * 取消当前订阅
 * http://schedulepost.dev.apphi.com/api/docs/#!/subscriptions/Subscription_unsubscribe
 */
export function cancel({ feedback }) {
  return fetch.delete(`subscriptions/self`, {
    data: { feedback }
  });
}

/**
 * 获取paypal 跳转链接
 * http://schedulepost.dev.apphi.com/api/docs/#!/subscriptions/Subscription_get_paypal_approval_url
 * @param plan_id plan唯一标示
 * @param immediate_downgrade_token 通过降级链接降级时多穿的token 2019.6.29
 * @returns {*}
 */
export function paypalUrl({ plan_id, sale, immediate_downgrade_token }) {
  return fetch.get(`subscriptions/paypal`, {
    params: {
      plan_id,
      sale,
      immediate_downgrade_token
    }
  });
}

/**
 * 采用paypal进行支付
 * http://schedulepost.dev.apphi.com/api/docs/#!/subscriptions/Subscription_execute_paypal_agreement
 */
export function paypalPay({ paypal_token, payment_id, payer_id }) {
  return fetch.post(
    `subscriptions/paypal`,
    { paypal_token, payment_id, payer_id },
    {
      timeout: 90000
    }
  );
}

/**
 * 获取历史支付记录
 * @param limit 每页条目
 * @param offset 页码 从0开始
 * @returns {*}
 */
export function history({ limit, offset }) {
  return fetch.get("subscriptions/events", {
    params: { limit, offset }
  });
}

/**
 * 获取优惠码对应信息
 * @param coupon 验证码
 * @returns {*}
 */
export function coupon({ coupon }) {
  return fetch.get(`subscriptions/stripe/coupon/${coupon}`);
}
/**
 * 接受取消订阅时的优惠
 * @param coupon 验证码
 * @returns {*}
 */
export function unsubscription({ unsubscription, feedback }) {
  return fetch.post(`users/self/ltos`, { unsubscription, feedback });
}

export async function createPaymentIntent(planId) {
  const {
    data: { clientSecret }
  } = await fetch.post("/subscriptions/stripe_payment_intents", {
    plan_id: planId
  });

  return clientSecret;
}

export async function createSetupIntent() {
  const {
    data: { clientSecret }
  } = await fetch.post("/subscriptions/stripe_setup_intents");

  return clientSecret;
}



// WEBPACK FOOTER //
// ./src/apis/payment.js